import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Preference {
    preference: string;
    preferenceValue: string;
}

export interface PreferencesState {
    isLoadingPreferences: boolean;
    preferences: Preference[];
    error: string | null;
}

const initialState: PreferencesState = {
    isLoadingPreferences: false,
    preferences: [],
    error: null,
};

export const preferencesSlice = createSlice({
    name: "preferences",
    initialState,
    reducers: {
        setIsLoadingPreferences: (state, action: PayloadAction<boolean>) => {
            state.isLoadingPreferences = action.payload;
        },
        setPreferences: (state, action: PayloadAction<Preference[]>) => {
            state.preferences = action.payload;
            state.error = null;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoadingPreferences = false;
        },
        clearPreferences: state => {
            state.preferences = [];
            state.error = null;
        },
    },
});

export const { setIsLoadingPreferences, setPreferences, setError, clearPreferences } =
    preferencesSlice.actions;

export default preferencesSlice.reducer;
